interface IApplicationUserConfig {
  userId?: string;
  session?: string;
  cheatUser?: boolean;
  language?: string;
  replayMode?: boolean;
  replayRoundId?: string;
}

export const DEFAULT_LANGUAGE = 'en';

export class ApplicationUserConfig {
  private static config: IApplicationUserConfig;

  public static init(config: IApplicationUserConfig): void {
    this.config = config;
  }

  public static get language(): string {
    return this.config.language || DEFAULT_LANGUAGE;
  }

  public static get userId(): string | null {
    return this.config.userId || null;
  }

  public static get session(): string | null {
    return this.config.session || null;
  }

  public static get cheatUser(): boolean {
    return this.config.cheatUser || false;
  }

  public static get replayMode(): boolean {
    return !!this.config?.replayMode;
  }

  public static get replayRoundId(): string | null {
    return this.config?.replayRoundId || null;
  }
}
